package games.polyclub.website.frontend.store.pages.logged

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.frontend.lib.react.utils.classes
import games.polyclub.frontend.lib.react.utils.useEffectAsync
import games.polyclub.message.unaryMinus
import games.polyclub.service.payment.api.OrderSummary
import games.polyclub.service.payment.api.PaymentStatus.*
import games.polyclub.service.payment.api.PurchaseType.*
import games.polyclub.tool.functional.retrying
import games.polyclub.tool.strings.formatted
import games.polyclub.tool.universal.Paginable
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.components.AsyncImg
import games.polyclub.website.frontend.store.components.Loading
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.userarea.UserAreaLayout
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import js.core.jso
import react.Props
import react.router.useNavigate
import react.useEffect
import react.useState
import web.cssom.Cursor
import web.cssom.None.Companion.none
import web.cssom.rem

val InvoicesPage = SFC<Props> { _ ->
    val navigate = useNavigate()
    val itemsPerPage = 10
    val (page, setPage) = useState(1)
    val (orderList, setOrderList) = useState<Paginable<OrderSummary>?>(null)

    useEffect(page) {
        if (page < 0) {
            setPage(1)
        }
    }

    appScope.useEffectAsync(page) {
        setOrderList(null)
        setOrderList(retrying {
            StoreBff.listOrderSumaries(page, itemsPerPage)
        })
    }

    UserAreaLayout {
        addBreadcrumb(LoggedSitemap.ORDERS.pathPart, -"Pedidos")
        if (orderList == null) {
            Loading()
            return@UserAreaLayout
        }
        Card {
            if (orderList.itemCount == 0) {
                +"Você não tem nenhuma transação"
                return@Card
            }
            table("table table-striped table-hover") {
                thead {
                    tr {
                        th {
                            style = jso {
                                width = 10.rem
                            }
                            +"Data / Hora"
                        }
                        th {
                            style = jso {
                                width = 15.rem
                            }
                            +"Situação"
                        }
                        th {
                            style = jso {
                                width = 5.rem
                            }
                            +"Total"
                        }
                        th {
                            +"Itens"
                        }
                    }
                }
                tbody {
                    orderList.pageItems.forEach { order ->
                        tr {
                            style = jso {
                                cursor = Cursor.pointer
                            }
                            onClick = {
                                it.preventDefault()
                                navigate("${LoggedSitemap.PAY_ROOT.path}/${order.id}")
                            }
                            td {
                                +order.at.formatted()
                            }
                            td {
                                when (order.status) {
                                    CREATING -> {
                                        classes = "text-info"
                                        i("fas fa-cog")
                                        +" "
                                        +"Criando..."
                                    }
                                    FAILED -> {
                                        classes = "text-gray"
                                        i("fas fa-times-circle")
                                        +" "
                                        +"Falhou"
                                    }
                                    AWAITING_PAYMENT -> {
                                        classes = "text-warning"
                                        i("fas fa-qrcode")
                                        +" "
                                        +"Aguardando Pagamento"
                                    }
                                    PAYMENT_EXPIRED -> {
                                        classes = "text-gray"
                                        i("fas fa-times-circle")
                                        +" "
                                        +"Expirado"
                                    }
                                    PAYMENT_CANCELED -> {
                                        classes = "text-gray"
                                        i("fas fa-times-circle")
                                        +" "
                                        +"Cancelado"
                                    }
                                    PAYMENT_DECLINED -> {
                                        classes = "text-danger"
                                        i("fas fa-times-circle")
                                        +" "
                                        +"Recusado"
                                    }
                                    PROCESSING -> {
                                        classes = "text-orange"
                                        i("fas fa-cog")
                                        +" "
                                        +"Processando..."
                                    }
                                    IN_ANALYSIS -> {
                                        classes = "text-orange"
                                        i("fas fa-search")
                                        +" "
                                        +"Em Análise..."
                                    }
                                    DISPUTE -> {
                                        classes = "text-danger"
                                        i("fas fa-handshake-slash")
                                        +" "
                                        +"Em Disputa"
                                    }
                                    PARTIALLY_REFUNDED -> {
                                        classes = "text-teal"
                                        i("fas fa-undo-alt")
                                        +" "
                                        +"Parcialmente Devolvido"
                                    }
                                    FULLY_REFUNDED -> {
                                        classes = "text-olive"
                                        i("fas fa-undo-alt")
                                        +" "
                                        +"Devolvido"
                                    }
                                    PAID, RELEASED -> {
                                        classes = "text-success"
                                        i("fas fa-check-circle")
                                        +" "
                                        +"Pago"
                                    }
                                }
                            }
                            td {
                                +order.total.toString()
                            }
                            td {
                                ul {
                                    order.items.forEach { item ->
                                        li {
                                            +"${item.quantity}x ${item.name}"
                                            when (item.purchaseType) {
                                                GIVEAWAY -> strong {
                                                    +" para ser sorteado"
                                                }
                                                NORMAL -> Unit
                                                GIFT -> {
                                                    +" para "
                                                    AsyncImg("img-circle elevation-2 bg-secondary") {
                                                        alt = ""
                                                        srcLoader = { StoreBff.avatarUrl(item.receiver.playerId) }
                                                        width = 32.0
                                                        height = 32.0
                                                    }
                                                    +" "
                                                    +item.receiver.playerName
                                                    if (item.purchaseType == GIFT) {
                                                        +" "
                                                        strong {
                                                            +"(Presente)"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            footer = ul.new {
                classes = "pagination pagination-sm m-0 float-right"
                li("page-item") {
                    a("page-link") {
                        style = jso {
                            cursor = Cursor.pointer
                        }
                        onClick = {
                            it.preventDefault()
                            setPage((page - 1).coerceAtLeast(1))
                        }
                        i("fas fa-angle-left")
                    }
                }
                val pagesToShow = (
                            (1..3).asSequence() +
                            ((orderList.page - 2)..(orderList.page + 2)) +
                            ((orderList.maxPage - 2)..orderList.maxPage)
                        ).filter { it in 1..orderList.maxPage }.distinct().sorted()
                var prev = 0
                pagesToShow.forEach { pageNum ->
                    if (pageNum - 1 != prev) {
                        li("page-item") {
                            a("page-link") {
                                style = jso {
                                    pointerEvents = none
                                }
                                onClick = { it.preventDefault() }
                                +"..."
                            }
                        }
                    }
                    prev = pageNum
                    li("page-item") {
                        if (pageNum == orderList.page) {
                            classSet += "active"
                        }
                        a("page-link") {
                            style = jso {
                                if (pageNum == orderList.page) {
                                    pointerEvents = none
                                } else {
                                    cursor = Cursor.pointer
                                }
                            }
                            onClick = {
                                it.preventDefault()
                                setPage(pageNum)
                            }
                            +pageNum.toString()
                        }
                    }
                }
                li("page-item") {
                    a("page-link") {
                        style = jso {
                            cursor = Cursor.pointer
                        }
                        onClick = {
                            it.preventDefault()
                            setPage(page + 1)
                        }
                        i("fas fa-angle-right")
                    }
                }
            }
        }
    }
}
